<div class="img-crop">
    <div class="h-100" [hidden]="!imgEditing">
        <div class="h-100 d-flex" style="align-items:center; justify-content:center;">
            <image-cropper (imageCropped)="emitChange($event)" output="base64" [roundCropper]="true" [imageBase64]="imgSrc"
                           [resizeToWidth]="500" [resizeToHeight]="500" [autoCrop]="true"
                           [containWithinAspectRatio]="false" [maintainAspectRatio]="true"
                           [alignImage]="'center'" [cropperMinWidth]="100" [cropperMinHeight]="100"></image-cropper>
        </div>
    </div>
    <div #candidateDropZone id="candidateDropZone" class="add_img_content" [hidden]="imgEditing" (click)="openFileBrowser($event);" 
         (drop)="uploadFile($event,'drop');" (dragover)="$event.preventDefault()"
         >
        <div class="add_img_p" cvLocalizedText langSection="Users" langKey="Drag_Drop_Image"></div>
        <div class="add_img_p" cvLocalizedText langSection="Users" langKey="Or"></div>
        <button type="button" (click)="openFileBrowser($event);" class="btn btn-primary" cvLocalizedText langSection="Users" langKey="Click_To_Browse" ></button>
        <input #candidatePhotoId (change)="uploadFile($event, 'form');" type="file" id="candidatePhotoId" />
    </div>
</div>
